import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalStorageService } from '../shared/local-storage.service';
import { Gear } from '../shared/gear.model';
import { ToastrService } from 'ngx-toastr';

/**
 * From the settings page, this small dialog presents an edit or delete option for gears.
 * From here send the selected option back and go from there.
 */
@Component({
    selector: 'app-gear-edit-dialog',
    templateUrl: './gear-edit-dialog.component.html',
    styleUrls: ['./gear-edit-dialog.component.css'],
    standalone: false
})
export class GearEditDialogComponent implements OnInit {

  gearName: string = "";

  constructor(
    public dataSync: LocalStorageService,
    public dialogRef: MatDialogRef<GearEditDialogComponent>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: {index: number, isHMS: boolean}) {

  }

  ngOnInit(): void {

    if (this.data != null) {
      this.gearName = this.dataSync.user_gear()[this.data.index].identifier;
    }
    else {
      this.toastr.error("Gear doesn't exist", "Something went wrong...");
      this.onNoClick();
    }

  }

  // delete current gear (deletion process same as in gear-select-dialog)
  deleteGear(): void {
    this.dialogRef.close("delete");
  }

  // edit currently selected gear
  editGear(): void {
    this.dialogRef.close("edit");
  }

  // close the gear dialog
  onNoClick(): void {
    this.dialogRef.close(-1);
  }

}
